import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Skeleton } from 'react-native-skeletons';
import { SkeletonText } from '@/components/skeleton-text';
import { useLayoutContext } from '@/contexts/layout-context';
import { useWindowDimensions, View } from 'react-native';

export const RADIUS = 8;
export const CAROUSEL_HEIGHT = 260;
export const CAROUSEL_HEIGHT_V2 = 350;
export const IMAGE_SIZE = 56;

const ITEM_HEIGHT = 180;
const ITEM_WIDTH = 146;
const ITEM_WIDTH_LARGE = 208;
const IMAGE_LARGE_SIZE = 122;

interface Props {
  testID?: string;
}

export const CatalogCarouselItemsLoading: React.FC<Props> = ({ testID }) => {
  const [styles] = useStyles();
  const dimensions = useWindowDimensions();
  const { isSmallLayout } = useLayoutContext();

  const itemSize = isSmallLayout ? ITEM_WIDTH : ITEM_WIDTH_LARGE;
  const imageSize = isSmallLayout ? IMAGE_SIZE : IMAGE_LARGE_SIZE;
  const maxWidthLoadingSkeletons = Math.ceil(dimensions.width / itemSize);

  return (
    <View style={styles.row} testID={testID}>
      {[...new Array(maxWidthLoadingSkeletons)].map((_, i) => (
        <View
          key={i}
          style={[
            styles.listItem,
            isSmallLayout ? styles.listItemSmall : styles.listItemLarge,
            { width: itemSize },
          ]}
        >
          <View style={styles.imageContainer}>
            <Skeleton
              borderRadius={RADIUS}
              height={imageSize}
              width={imageSize}
            />
          </View>
          <View style={styles.textContainer}>
            <SkeletonText height={12} />
            <SkeletonText height={8} width="80%" />
            {isSmallLayout ? <SkeletonText height={8} width="60%" /> : null}
          </View>
          {isSmallLayout ? null : (
            <View style={styles.textContainer}>
              <SkeletonText height={8} width="60%" />
              <SkeletonText height={8} width="40%" />
            </View>
          )}
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  imageContainer: {
    alignItems: 'center',
  },
  listItem: {
    borderRadius: RADIUS,
    padding: 12,
  },
  listItemLarge: {
    borderColor: theme.colors.stroke,
    borderWidth: 1,
  },
  listItemSmall: {
    backgroundColor: theme.colors.white,
    height: ITEM_HEIGHT,
  },
  row: {
    flexDirection: 'row',
    gap: 16,
  },
  textContainer: {
    marginTop: 12,
  },
}));
